<template>
    <v-dialog v-model="shows" max-width="320" persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on, disabled }" />
        </template>
        <v-card>
            <v-card-title>선택 인사장 업로드</v-card-title>
            <v-card-text class="pb-0">
                <v-row class="mx-n2">
                    <v-col>
                        <v-file-input v-model="file" v-bind="{ attrs_input }"/>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-subheader class="caption">
                    선택된 항목 총
                    <span class="mx-1 text-subtitle-1 font-weight-bold primary--text">
                        {{ selected.length }}
                    </span>
                    건
                </v-subheader>
                <v-spacer />
                <v-btn text color="primary" @click="shows = false">취소</v-btn>
                <v-btn text color="primary" v-bind="{ disabled }" @click="save">업로드</v-btn>
            </v-card-actions>
            <v-fade-transition>
                <v-overlay v-show="loading" absolute light color="white">
                    <v-sheet width="240" rounded style="overflow: hidden">
                        <v-progress-linear :value="(updatedLength / selected.length) * 100" height="24">
                            <span> {{ updatedLength }} / {{ selected.length }} </span>
                        </v-progress-linear>
                    </v-sheet>
                </v-overlay>
            </v-fade-transition>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables";

export default {
    components: {
    },
    props: {
        selected: { type: Array, default: () => [] },
    },
    data: () => ({
        shows: false,
        loading: false,

        updatedLength: 0,
        file: null,

        attrs_input,
    }),
    computed: {
        disabled() {
            return !this.selected.length;
        },
    },
    watch: {
    },
    methods: {
        async save() {
            if (this.loading) return;
            this.loading = true;

            let { file } = await api.console.shop.purchaseOrders.files.post(this.file);

            let orders = [];
            for (const { _id } of this.selected) {
                orders.push((await api.console.shop.purchaseOrders.put({ _id, _greetingCard: file._id  }))?.order);
                this.updatedLength += 1;
            }
            setTimeout(() => {
                alert("변경되었습니다");
                this.$emit("updateItems", orders);
                this.loading = false;
                this.shows = false;
            }, 500);
        },

        async upload(code) {
        },
    },
};
</script>

<style>
</style>